import { BaseModel } from './base.model';

export class FilterItem extends BaseModel {
    public id: string | number;
    public attr_id: string | number;
    public ord: number;
    public label: string;
    public selected: boolean;
    public isChild: boolean;
    public isVisible = true;
    public isValid = true;
    // derived properties
    public children: FilterItem[];

    constructor(data) {
        super(data, {
            num: [ 'ord'],
            bool: ['selected']
        });

        if (!this.children) {
           this.children = [];
        } else {
            this.children = this.children.map( item => new FilterItem(item));
        }

        if (!this.ord) {
            this.ord = 0;
        }

        if (data.isValid === false) {
            this.isValid = false;
        }
    }

    public clearSelection() {
        this.selected = false;
        this.children.forEach( child => child.clearSelection());
    }

    public clearDisplay() {
        this.isValid = true;
        this.children.forEach(child => child.clearDisplay());
    }
}
